module.exports = __webpack_public_path__ + "static/partners-main-05043ebc80a45433e411c25482722195.jpeg";